import { render, staticRenderFns } from "./DashboardAdviceItem.vue?vue&type=template&id=00e9a712&scoped=true&"
import script from "./DashboardAdviceItem.vue?vue&type=script&lang=js&"
export * from "./DashboardAdviceItem.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAdviceItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DashboardAdviceItem.vue?vue&type=style&index=1&id=00e9a712&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e9a712",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarouselItem})
